import {useGetComponentsForEquipments} from "../../hooks/Administrative/useGetComponentsForEquipments";
import {useGetEquipments} from "../../hooks/Administrative/useGetEquipments";
import React, {useEffect, useState} from "react";
import {useGetEquipmentByUniqueCode} from "../../hooks/Administrative/useGetEquipmentByUniqueCode";
import {useUpdateEquipment} from "../../hooks/Administrative/useUpdateEquipment";
import Table from "../Table/Table";

const columns = ['PLANTA', 'CLIENTE','DOSIFICADOR','ADITIVO'];

const NestedEquipmentView  = ({onBack, clientId}: { onBack: () => void; clientId: string })=> {

    const [filters, setFilters] = useState({clientId});

    const {equipments, totalPages, isLoading, page, setPage} = useGetEquipments({filters});

    const {dispenser, controller, tank, agitator, additives, clients} = useGetComponentsForEquipments();
    const [plants, setPlants] = useState<any>([]);

    const [showEditEquipment, setShowEditEquipment] = useState(false);
    const { equipment, fetchEquipmentByUniqueCode } = useGetEquipmentByUniqueCode();

    const [editDisabled, setEditDisabled] = useState(true);

    const [localEquipmentPlantUniqueCode, setLocalEquipmentPlantUniqueCode] = useState("");
    const [localEquipmentClientUniqueCode, setLocalEquipmentClientUniqueCode] = useState("");
    const [localEquipmentDispenserCode, setLocalEquipmentDispenserCode] = useState("");
    const [localEquipmentAgitatorCode, setLocalEquipmentAgitatorCode] = useState("");
    const [localEquipmentTankCode, setLocalEquipmentTankCode] = useState("");
    const [localEquipmentControllerCode, setLocalEquipmentControllerCode] = useState("");
    const [localEquipmentAdditiveCode, setLocalEquipmentAdditiveCode] = useState("");

    const {updatingEquipment} = useUpdateEquipment();


    useEffect(() => {
        if (equipment) {
            setLocalEquipmentClientUniqueCode(setLocalEquipmentAndPlantsByPlantUniqueCode(equipment.plantUniqueCode));
            setLocalEquipmentPlantUniqueCode(equipment.plantUniqueCode);
            setLocalEquipmentDispenserCode(equipment.dispenserUniqueCode);
            setLocalEquipmentAgitatorCode(equipment.agitatorUniqueCode);
            setLocalEquipmentTankCode(equipment.tankUniqueCode);
            setLocalEquipmentControllerCode(equipment.controllerUniqueCode);
            setLocalEquipmentAdditiveCode(equipment.additiveUniqueCode);
        }
    }, [equipment]);

    const setLocalEquipmentAndPlantsByPlantUniqueCode = (plantUniqueCode: string): string => {
        const clientName: string = findClientByPlantKey(plantUniqueCode);
        const selectedClient: any = clients[clientName];
        setPlants(selectedClient);
        return clientName;
    };

    const findClientByPlantKey = (plantUniqueCode: string) => {
        for (const client in clients) {
            if (clients[client].hasOwnProperty(plantUniqueCode)) {
                return client;
            }
        }
        return "";
    }


    const handleResetClientsTable = () => {
        setFilters({clientId});
        setPage(0);
        setEditDisabled(true);
        setShowEditEquipment(false);
    };

    const handleOnRowClick = (row: Record<string, any>) => {
        setShowEditEquipment(true);
        fetchEquipmentByUniqueCode(row.ID);
    };

    return (
        <div className="additive-view-container">
            <div className="additive-view-left">
                <div className="additive-view-header">
                    <button onClick={onBack}>REGRESAR</button>
                    <div className="additive-view-header-title">
                        <p>EQUIPOS DOSIFICADORES</p>
                    </div>
                    <span className="material-icons-outlined icon-unselected" onClick={handleResetClientsTable}>
                    restart_alt
                </span>
                </div>
                {isLoading ?
                    (
                        <div className="loading-overlay">
                            <div className="spinner"></div>
                            <div className="loading-message">Obteniendo información...</div>
                        </div>
                    ) : (
                        <div className="additive-table-container">
                            <Table
                                columns={columns}
                                data={equipments}
                                totalPages={totalPages}
                                currentPage={page}
                                setCurrentPage={setPage}
                                onRowClick={handleOnRowClick}
                            />
                        </div>
                    )}
            </div>
            <div className="add-additive">
                {updatingEquipment ? (
                    <div className="loading-overlay-for-additive-view">
                        <div className="spinner"></div>
                        <div className="loading-message">Guardando</div>
                    </div>) : (
                    <div>
                        {showEditEquipment && (
                            <div>
                                <div className="plants-info-view-header">
                                    <div className="plants-info-view-header-title">
                                        <p>ASIGNADOS</p>
                                    </div>
                                </div>
                                <div className="plants-info-fields">
                                    <div className="client-info-attribute">
                                        <div className="client-attribute-label">CLIENTE</div>
                                        {editDisabled ? (
                                            <input
                                                className={`value-label`}
                                                type="text"
                                                value={localEquipmentClientUniqueCode}
                                                disabled={editDisabled}
                                            />
                                        ) : (
                                            <select
                                                className="value-label"
                                                value={localEquipmentClientUniqueCode}
                                            >
                                                <option value=""></option>
                                                {clients && Object.keys(clients).length > 0 ? (
                                                    Object.keys(clients).map((clientKey) => (
                                                        <option key={clientKey} value={clientKey}>
                                                            {clientKey}
                                                        </option>
                                                    ))
                                                ) : (
                                                    <option value="" disabled>
                                                        No hay clientes disponibles
                                                    </option>
                                                )}
                                            </select>
                                        )}
                                    </div>

                                    <div className="client-info-attribute">
                                        <div className="client-attribute-label">PLANTA</div>
                                        {editDisabled ? (
                                            <input
                                                className={`value-label`}
                                                type="text"
                                                value={localEquipmentPlantUniqueCode}
                                                disabled={editDisabled}
                                                onChange={(e) => setLocalEquipmentPlantUniqueCode(e.target.value)}
                                            />
                                        ) : (
                                            <select
                                                id="plantaDropdown"
                                                className={`value-label`}
                                                value={localEquipmentPlantUniqueCode}
                                                onChange={(e) => setLocalEquipmentPlantUniqueCode(e.target.value)}
                                                disabled={!localEquipmentClientUniqueCode || !plants || Object.keys(plants).length === 0}
                                            >
                                                <option value=""></option>
                                                {plants && Object.entries(plants).length > 0 ? (
                                                    Object.entries(plants).map(([key, value]: any) => (
                                                        <option key={key} value={key}>
                                                            {value}
                                                        </option>
                                                    ))
                                                ) : (
                                                    <option value="" disabled>
                                                        No hay plantas disponibles
                                                    </option>
                                                )}
                                            </select>
                                        )}
                                    </div>

                                    <div className="client-info-attribute">
                                        <div className="client-attribute-label">DOSIFICADOR</div>
                                        {editDisabled ? (
                                            <input
                                                className={`value-label`}
                                                type="text"
                                                value={localEquipmentDispenserCode}
                                                disabled={editDisabled}
                                                onChange={(e) => setLocalEquipmentDispenserCode(e.target.value)}
                                            />
                                        ) : (
                                            <select
                                                className={`value-label`}
                                                value={localEquipmentDispenserCode}
                                                onChange={(e) => setLocalEquipmentDispenserCode(e.target.value)}
                                            >
                                                <option value=""></option>
                                                {dispenser && Object.entries(dispenser).length > 0 ? (
                                                    Object.entries(dispenser).map(([key, value]: any) => (
                                                        <option key={key} value={key}>
                                                            {value}
                                                        </option>
                                                    ))
                                                ) : (
                                                    <option value="" disabled>
                                                        No hay dosificadores disponibles
                                                    </option>
                                                )}
                                            </select>
                                        )}
                                    </div>

                                    <div className="client-info-attribute">
                                        <div className="client-attribute-label">AGITADOR</div>
                                        {editDisabled ? (
                                            <input
                                                className={`value-label`}
                                                type="text"
                                                value={localEquipmentAgitatorCode}
                                                disabled={editDisabled}
                                                onChange={(e) => setLocalEquipmentAgitatorCode(e.target.value)}
                                            />
                                        ) : (
                                            <select
                                                className={`value-label`}
                                                value={localEquipmentAgitatorCode}
                                                onChange={(e) => setLocalEquipmentAgitatorCode(e.target.value)}
                                            >
                                                <option value=""></option>
                                                {agitator && Object.entries(agitator).length > 0 ? (
                                                    Object.entries(agitator).map(([key, value]: any) => (
                                                        <option key={key} value={key}>
                                                            {value}
                                                        </option>
                                                    ))
                                                ) : (
                                                    <option value="" disabled>
                                                        No hay agitadores disponibles
                                                    </option>
                                                )}
                                            </select>
                                        )}
                                    </div>

                                    <div className="client-info-attribute">
                                        <div className="client-attribute-label">CONTROLADOR</div>
                                        {editDisabled ? (
                                            <input
                                                className={`value-label`}
                                                type="text"
                                                value={localEquipmentControllerCode}
                                                disabled={editDisabled}
                                                onChange={(e) => setLocalEquipmentControllerCode(e.target.value)}
                                            />
                                        ) : (
                                            <select
                                                className={`value-label`}
                                                value={localEquipmentControllerCode}
                                                onChange={(e) => setLocalEquipmentControllerCode(e.target.value)}
                                            >
                                                <option value=""></option>
                                                {controller && Object.entries(controller).length > 0 ? (
                                                    Object.entries(controller).map(([key, value]: any) => (
                                                        <option key={key} value={key}>
                                                            {value}
                                                        </option>
                                                    ))
                                                ) : (
                                                    <option value="" disabled>
                                                        No hay controladores disponibles
                                                    </option>
                                                )}
                                            </select>
                                        )}
                                    </div>

                                    <div className="client-info-attribute">
                                        <div className="client-attribute-label">TANQUE</div>
                                        {editDisabled ? (
                                            <input
                                                className={`value-label`}
                                                type="text"
                                                value={localEquipmentTankCode}
                                                disabled={editDisabled}
                                                onChange={(e) => setLocalEquipmentTankCode(e.target.value)}
                                            />
                                        ) : (
                                            <select
                                                className={`value-label`}
                                                value={localEquipmentTankCode}
                                                onChange={(e) => setLocalEquipmentTankCode(e.target.value)}
                                            >
                                                <option value=""></option>
                                                {tank && Object.entries(tank).length > 0 ? (
                                                    Object.entries(tank).map(([key, value]: any) => (
                                                        <option key={key} value={key}>
                                                            {value}
                                                        </option>
                                                    ))
                                                ) : (
                                                    <option value="" disabled>
                                                        No hay tanques disponibles
                                                    </option>
                                                )}
                                            </select>
                                        )}
                                    </div>

                                    <div className="client-info-attribute">
                                        <div className="client-attribute-label">ADITIVO</div>
                                        {editDisabled ? (
                                            <input
                                                className={`value-label`}
                                                type="text"
                                                value={localEquipmentAdditiveCode}
                                                disabled={editDisabled}
                                                onChange={(e) => setLocalEquipmentAdditiveCode(e.target.value)}
                                            />
                                        ) : (
                                            <select
                                                className={`value-label`}
                                                value={localEquipmentAdditiveCode}
                                                onChange={(e) => setLocalEquipmentAdditiveCode(e.target.value)}
                                            >
                                                <option value=""></option>
                                                {additives && Object.entries(additives).length > 0 ? (
                                                    Object.entries(additives).map(([key, value]: any) => (
                                                        <option key={key} value={key}>
                                                            {value}
                                                        </option>
                                                    ))
                                                ) : (
                                                    <option value="" disabled>
                                                        No hay aditivos disponibles
                                                    </option>
                                                )}
                                            </select>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}

export default NestedEquipmentView;